// extracted by mini-css-extract-plugin
export default {"Container":"Federal_Container__WhtN4","section-1":"Federal_section-1__LMR7h","content":"Federal_content__fBvFr","ul":"Federal_ul__8fSfy","section-2":"Federal_section-2__HPZPs"};